<template>
  <!-- <div class="iBusiness-wrapper"> -->
  <div :class="classData.iBusinessSide" :style="styleData.mainDiv">
    <div :class="classData.styleLogo">
      <img class="logo-img" src="@/assets/images/logo.png" alt="logo" />
      <span class="ml5">{{ $t('bp.logo_text') }}</span>
    </div>
    <nav class="nav-wrapper">
      <ul class="nav">
        <li
          @click="changeSelect(i)"
          v-for="(r,i)  in routeData"
          :key="r.path"
          class="nav-item"
        >
          <router-link :to="r.path" :class="isactive == i ? 'nav-this' : ''">
            <svg class="icon" aria-hidden="true">
              <use :xlink:href="'#' + r.icon" />
            </svg>
            <span class="ml5" v-if="styleData.textSeen">{{ $t(r.name) }}</span>
          </router-link>
        </li>
      </ul>
    </nav>
    <div class="side-bottom">
      <div id="iconShrink" @click="foldFirMenu()" class="icon-wrapper">
        <svg class="icon" :style="styleData.iconShrinkIcon" aria-hidden="true">
          <use xlink:href="#iconmenu-retractarrow" />
        </svg>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SideBar',
  props: {},
  computed: {
    ...mapState('user', ['authRoutes'])
  },
  data() {
    return {
      flag: false,
      isactive: -1,
      classData: {
        iBusinessSide: 'iBusiness-side',
        styleLogo: 'logo'
      },
      styleData: {
        mainDiv: '',
        iconShrinkIcon: '',
        textSeen: true
      },
      routeData: []
    }
  },
  methods: {
    foldFirMenu() {
      if (this.flag) {
        this.styleData.mainDiv = 'width:160px'
        this.styleData.iconShrinkIcon = 'transform:rotate(0)'
        this.styleData.textSeen = true
        this.classData.styleLogo = 'logo'
        this.flag = false
      } else {
        this.styleData.mainDiv = 'width:58px'
        this.styleData.iconShrinkIcon = 'transform:rotate(180deg)'
        this.styleData.textSeen = false
        this.classData.styleLogo = 'logo logo-shrink'
        this.flag = true
      }
      this.$store.commit('app/TOGGLE_SIDEBAR')
    },
    changeSelect(index) {
      this.isactive = index
    },
    loadMenu() {
    }
  },
  mounted() {
    this.routeData = this.authRoutes.filter(item => item.hide !== true)
    const list = this.authRoutes
    for (let j = 0, len = list.length; j < len; j++) {
      if (this.$route.path.startsWith(list[j].path + '/')) {
        this.isactive = j
      } else if (list[j].path === this.$route.path) {
        this.isactive = j
      }
    }
  },
  watch: {
    $route: function (to, from) {
      const list = this.authRoutes
      for (let j = 0, len = list.length; j < len; j++) {
        if (to.path.startsWith(list[j].path + '/')) {
          this.isactive = j
        } else if (list[j].path === to.path) {
          this.isactive = j
        }
      }
    }
  }
}
</script>

<style lang="scss">
.ml5 {
  margin-left: 5px;
}
</style>
